import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { API_URL } from '../../config';
import { toast } from 'react-toastify';

const ChangePreferredContactPopup = ({ selectedPlateId, isOpen, onRequestClose, loadPlateRenewalData }) => {
  const [notificationMethods, setNotificationMethods] = useState([]);

  useEffect(() => {
    if (isOpen) fetchNotificationMethods();
  }, [isOpen]);

  const fetchNotificationMethods = () => {
    const authToken = localStorage.getItem('token');
    if (!authToken) return;

    fetch(`${API_URL}/customer/notification/methods`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    })
      .then((response) => { if (!response.ok) throw new Error('Network response was not ok'); return response.json(); })
      .then((data) => setNotificationMethods(data))
      .catch((error) => console.error('Error fetching notification methods:', error));
  };

  const makePreferredContact = (contactId) => {
    const authToken = localStorage.getItem('token');
    if (!authToken) return;

    fetch(`${API_URL}/plate-renewals/${selectedPlateId}/update-contact-id`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${authToken}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ contact_id: contactId }),
    })
      .then((response) => { if (!response.ok) throw new Error('Network response was not ok'); return response.json(); })
      .then((data) => {
        toast.success('Preferred contact updated successfully', { autoClose: 3000 });
        onRequestClose();
        loadPlateRenewalData();
      })
      .catch((error) => toast.error('Failed to set preferred contact', { autoClose: 3000 }));
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="tw-bg-white tw-rounded-xl tw-shadow-2xl tw-max-w-lg tw-w-full tw-mx-4 tw-max-h-[90vh] tw-overflow-y-auto tw-p-6 tw-outline-none"
      overlayClassName="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-[9999]"
    >
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-6">
        <h2 className="tw-text-xl tw-font-bold tw-text-gray-900 tw-m-0">Choose Preferred Contact</h2>
        <button onClick={onRequestClose} className="tw-text-gray-400 hover:tw-text-gray-600 tw-border-0 tw-bg-transparent tw-cursor-pointer tw-p-1">
          <FontAwesomeIcon icon={faTimes} className="tw-text-lg" />
        </button>
      </div>

      {notificationMethods.length === 0 ? (
        <p className="tw-text-sm tw-text-gray-500 tw-text-center tw-py-6 tw-m-0">No contacts available. Add a contact from your Profile first.</p>
      ) : (
        <div className="tw-overflow-x-auto tw-rounded-lg tw-border tw-border-gray-200">
          <table className="tw-w-full">
            <thead>
              <tr className="tw-border-b tw-border-gray-200 tw-bg-gray-50">
                <th className="tw-text-left tw-px-4 tw-py-3 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wider">Email</th>
                <th className="tw-text-left tw-px-4 tw-py-3 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wider">Phone</th>
                <th className="tw-text-right tw-px-4 tw-py-3 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody className="tw-divide-y tw-divide-gray-100">
              {notificationMethods.map((contact) => (
                <tr key={contact.id} className="hover:tw-bg-gray-50 tw-transition-colors">
                  <td className="tw-px-4 tw-py-3 tw-text-sm tw-text-gray-700">{contact.email}</td>
                  <td className="tw-px-4 tw-py-3 tw-text-sm tw-text-gray-700">{contact.phone}</td>
                  <td className="tw-px-4 tw-py-3 tw-text-right">
                    <button
                      onClick={() => makePreferredContact(contact.id)}
                      className="tw-text-sm tw-text-blue-600 hover:tw-text-blue-700 tw-font-medium tw-border-0 tw-bg-transparent tw-cursor-pointer"
                    >
                      Choose
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  );
};

export default ChangePreferredContactPopup;
